import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";

import BarraDeNavegacao from "../../componentes/BarraDeNavegacao";
import Container from "../../componentes/Container";
import InativacaoDeInscricaoDadosPessoais from "../../componentes/InativacaoDeInscricao";
import InativacaoDeInscricaoconfirmacaoDeInativacao from "../../componentes/InativacaoDeInscricao/confirmacaoDeInativacao";
import { ArrowDownIcone } from "../../componentes/InativacaoDeInscricao/Icones/arrowDown";

import { consultarInscricaoParaInativacao } from "../../servicos/inativacaoDeInscricao";
import { GerenciadorDeMensagem } from "@digix-ui/componentes";
import { IConsultaParaInativacao } from "../../interfaces/IInativacaoDeInscricao";

import "./styles.scss";

const InativacaoDeInscricao = () => {

  const { idDaInscricao, temPermissao } = useMemo(() => {
    const idDaInscricao = localStorage.getItem("idDaInscricao");
    const temPermissao = localStorage.getItem(
      "temPermissaoParaInativarInscricao"
    );
    return {
      idDaInscricao,
      temPermissao,
    };
  }, []);
  
  const [dadosParaInativacao, setDadosParaInativacao] = useState<
    IConsultaParaInativacao["data"] | null
  >(null);
  
  const [mensagensDeErro, setMensagensDeErro] = useState<string[]>([]);

  const dispatch = useDispatch();

  const handleMensagensDeErro = (dados: IConsultaParaInativacao["data"]) => {
    if (!dados) return;

    const mensagens: string[] = [];

    if (dados.estaNaListaPrincipalOuReserva)
      mensagens.push(
        "A inscrição está em uma lista de um processo de seleção."
      );

    if (dados.possuiContrato)
      mensagens.push(
        "A inscrição possui contrato ou financiamento cadastrado."
      );

    if (dados.estaContemplado)
      mensagens.push("A inscrição está cadastrada no módulo Contemplados.");

    if (dados.possuiSolicitacaoNoControleDeSaldo)
      mensagens.push("A inscrição possui alguma solicitação em andamento.");

    setMensagensDeErro(mensagens);
  };

  useEffect(() => {
    const carregarDados = async () => {
      if (!idDaInscricao) return;

      const resposta = await consultarInscricaoParaInativacao(+idDaInscricao);
      const inscricao = resposta.data;

      setDadosParaInativacao(inscricao);
      handleMensagensDeErro(inscricao);
    };

    carregarDados();
  }, [idDaInscricao]);

  useEffect(() => {
    if (temPermissao !== "true") {
      GerenciadorDeMensagem.criarMensagem({
        tipo: "erro",
        icone: "far fa-times-circle",
        titulo: "Inativacão de inscrição:",
        texto: "Permissão negada para executar esta ação.",
      });
      dispatch(push("/listagem-de-inscricoes"));
    }
  }, [temPermissao, dispatch]);

  return (
    <div className="container-inativacao-inscricao">
      <BarraDeNavegacao
        titulo="Inativação de inscrição"
        comBotaoVoltar
        acaoBotaoVoltar={() => dispatch(push("/listagem-de-inscricoes"))}
        comBotaoADireita={false}
        iconeBotaoADireita={false}
        acaoBotaoADireita={() => dispatch(push("/menu-inscricao"))}
      />
      <Container tamanhoDoContainer="grande" comCabecalhoFixo>
        <div className="sub-container-inativacao-inscricao">
          <ArrowDownIcone />
          <h2 className="cartao__titulo texto_cor-secundaria">
            Inativar inscrição
          </h2>
          <p className="cartao__subtitulo">
            Uma inscrição inativa deixa de aparecer em pesquisas na listagem
            pública ou participa de processos de seleção.
          </p>

          {dadosParaInativacao && (
            <InativacaoDeInscricaoDadosPessoais
              titular={dadosParaInativacao.inscricao.titular}
              protocolo={dadosParaInativacao.inscricao.numero}
              mensagensDeErro={mensagensDeErro}
            />
          )}

          {dadosParaInativacao && mensagensDeErro.length === 0 && (
            <InativacaoDeInscricaoconfirmacaoDeInativacao
              idDaInscricao={dadosParaInativacao.inscricao.id}
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default InativacaoDeInscricao;
